<template>
  <div>
    <TriangleHeader :title="$t('Auctions And Tenders')"
    />
    <div class="mt-12 text-center">
      <h5 class="font-weight-bold">{{$t('auctions_and_tenders_question')}}</h5>
      <h5 class="font-weight-bold">{{$t('auctions_and_tenders_first_description')}}</h5>
      <h5 class="font-weight-bold">{{$t('auctions_and_tenders_second_description')}}</h5>
    </div>
    <v-row style="margin-top: 50px!important;margin-bottom: 100px!important;"
           :class="$vuetify.breakpoint.mdAndUp?'w-60':'w-100'"
           class=" mx-auto">
      <v-col cols="12" md="4" xl="4" lg="4" v-for="(filter,index) in filters"
             class="parent-box"
             :key="index"
             @click="selectedTab=index"
      >
        <div class="disable-item">
          <div class="icon-outline-box">
            <div class="icon-box">
              <v-img :src="filter.img" width="72"></v-img>
            </div>
          </div>
          <div class="content-box">
            <h4 class="font-weight-bold text-center mt-4">{{ $t(filter.title) }}</h4>
            <h6 class="font-weight-bold text-center mt-4">{{ $t(filter.content) }}</h6>
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import TriangleHeader from "../../components/triangle_header/TriangleHeader";
import Inquiry from "./inquiry";
import {GET_AUCTIONS, GET_INQUIRY, GET_TENDERS} from "../../store/invitedToCooperateManagement/action_type";
import Auctions from "./auctions";
import Tenders from "./tenders";

export default {
  name: "auctionsAndTenders",
  components: {Tenders, Auctions, Inquiry, TriangleHeader},
  watch: {
    selectedTab() {
      this.getData();
    }
  },
  methods: {
    getData() {
      switch (this.selectedTab) {

        case 0:
          this.getAuctions();

          break;

        case 1:
          this.getTenders();
          break;

        case 2:
          this.getInquiry();
          break;
      }
    },
    getAuctions() {
      this.$router.push('/auctions')
    },
    getTenders() {
      this.$router.push('/tenders')
    },
    getInquiry() {
      this.$router.push('/inquiry')
    }
  },
  data() {
    return {
      selectedTab: null,
      filters: [
        {
          id: 1,
          title: 'auctions',
          img: require('../../assets/icons/auction.png'),
          content: 'auctions_description'
        },
        {
          id: 2,
          title: 'tenders',
          img: require('../../assets/icons/tender.png'),
          content: 'tenders_description'
        },
        {
          id: 3,
          title: 'inquiry',
          img: require('../../assets/icons/inquiry.png'),
          content: 'inquiry_description'
        },
      ],
    }
  },
}
</script>

<style scoped>

/*.icon-box {*/
/*  width: 100px;*/
/*  height: 100px;*/
/*  border-radius: 100px;*/
/*  background-color: #25458c;*/
/*  display: flex;*/
/*  justify-content: center;*/
/*  align-items: center;*/
/*  padding: 20px;*/
/*  border: 3px solid white;*/
/*  z-index: 100;*/
/*}*/

.icon-outline-box {
  cursor: pointer;
}

/*.parent-box {*/
/*  position: relative;*/
/*  display: flex;*/
/*  justify-content: center;*/
/*  align-items: center;*/
/*  text-align: center;*/
/*  margin-bottom: 140px;*/
/*}*/

/*!*.parent-box:hover .icon-outline-box {*!*/
/*!*  background-color: #FCC300;*!*/
/*!*}*!*/

/*.parent-box:hover .icon-box {*/
/*  background-color: #FCC300;*/
/*}*/

/*!*.parent-box:hover h4 {*!*/
/*!*  color:#FCC300!important;*!*/
/*!*}*!*/


/*.content-box {*/
/*  cursor: pointer;*/
/*  width: 300px;*/
/*  height: 180px;*/
/*  !*background-color: #f5f5f5;*!*/
/*  !*border-radius: 4px;*!*/
/*  position: absolute;*/
/*  top: 50px;*/
/*  !*border: 1px solid #25458c;*!*/
/*  padding-top: 70px;*/
/*}*/

.disable-item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

</style>